import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import {
    decryptMessage,
    setEncryptionSecret,
    useConversationStatusContext,
} from '@speeki/firebase-chat';
import { DateFormat } from '@speeki/frontend-utils';

import { getPath } from '@services/RouteService/paths';

import {
    DateCell,
    IconArrow,
    IconMailPoint,
    IconMailWrapper,
    ListItem,
    MessageCell,
    Point,
    ReportCell,
    StatusCell,
} from './CasesListItem.styled';

interface CasesListItemProps {
    chatRoomSecret: string;
    id: string;
    isStatusChanged: boolean;
    reportId: string;
    status: string;
    testId: string;
}

export const CasesListItem = ({
    chatRoomSecret,
    id,
    isStatusChanged,
    reportId,
    status,
    testId,
}: CasesListItemProps) => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const conversationStatus = useConversationStatusContext(id);

    const {
        messageContent,
        sentAt,
        status: lastMessageSatus,
    } = conversationStatus || {};

    const renderMessage = () => {
        if (chatRoomSecret) {
            setEncryptionSecret(id, chatRoomSecret);

            const decryptedMessage = decryptMessage(id, messageContent);

            if (lastMessageSatus === 'new') {
                if (sentAt && !decryptedMessage)
                    return t('CHAT_NEW_FILE_MESSAGE');
                if (!!decryptedMessage) return decryptedMessage;
            }
        }

        return t('CHAT_NO_MESSAGES');
    };

    const isNewMessage = lastMessageSatus === 'new';
    const lastMessageDate = sentAt?.seconds
        ? DateFormat.standard(sentAt.toDate())
        : '';

    return (
        <ListItem
            data-testid={testId}
            onClick={() =>
                navigate(
                    getPath({
                        params: { caseId: reportId },
                        path: '/incidents/reports/:caseId',
                    }),
                )
            }
        >
            <ReportCell data-testid="bIVrVg0">{reportId}</ReportCell>
            <StatusCell data-testid="qGncrJn" unread={isStatusChanged}>
                {t(status.toUpperCase(), { ns: 'caseStatus' })}
            </StatusCell>
            <MessageCell data-testid="2R8kR8C" unread={isNewMessage}>
                {renderMessage()}
            </MessageCell>
            <IconMailWrapper data-testid="8wU-trT">
                {isNewMessage && <IconMailPoint />}
            </IconMailWrapper>
            <DateCell data-testid="J8rnL3S">{lastMessageDate}</DateCell>
            <IconArrow
                data-testid="wWH1xAL"
                icon={'SvgChevronRight24'}
                size={24}
            />
            {(isStatusChanged || isNewMessage) && <Point />}
        </ListItem>
    );
};
